<template>
  <form
    accept-charset="utf-8"
    id="register"
    method="post"
    role="form"
    v-on:submit="register($event)"
  >
    <div class="bg-white border-secondary shadow-sm rounded p-3 h-100 mt-2 mb-5">
      <div class="text-step">
        <h5>
          <span class="badge badge-pill badge-warning mr-3">STEP 3</span>
          <span class="title pt-2 mt-2">สร้างบัญชี</span>
        </h5>
      </div>
      <div class="mt-3">
        <div class="form-group row">
          <b-col cols="12" sm="3" md="3" lg="2">
            <label class="col-form-label" for="username">ชื่อ - นามสกุล</label>
          </b-col>
          <b-col cols="12" sm="4" md="4" lg="5">
            <input
              type="text"
              class="form-control"
              id="firstName"
              required
              placeholder="ชื่อ"
              v-model="user.firstName"
            />
          </b-col>
          <b-col cols="12" sm="5" md="5" lg="5">
            <input
              type="text"
              class="form-control"
              id="lastName"
              required
              placeholder="นามสกุล"
              v-model="user.lastName"
            />
          </b-col>
        </div>
      </div>
      <div class="mt-3">
        <div class="form-group row">
          <b-col cols="12" sm="3" md="3" lg="2">
            <label class="col-form-label" for="username">ชื่อผู้ใช้งาน</label>
          </b-col>
          <b-col cols="12" sm="9" md="9" lg="10">
            <input
              type="text"
              class="form-control"
              id="username"
              required
              placeholder="Username (0-9,a-z)"
              v-model="user.username"
               v-on:keypress="isLetter($event)"
            />
          </b-col>
        </div>
        <div class="form-group row">
          <b-col cols="12" sm="3" md="3" lg="2">
            <label class="col-form-label" for="password">รหัสผ่าน</label>
          </b-col>
          <b-col cols="12" sm="9" md="9" lg="10">
            <input
              type="password"
              class="form-control"
              id="password"
              minlength="6"
              required
              placeholder="Password"
              v-model="user.password"
            />
          </b-col>
        </div>
        <div class="form-group row">
          <b-col cols="12" sm="3" md="3" lg="2">
            <label class="col-form-label" for="confirm_password">ยืนยันรหัสผ่าน</label>
          </b-col>
          <b-col cols="12" sm="9" md="9" lg="10">
            <input
              type="password"
              class="form-control"
              id="confirm_password"
              required
              minlength="6"
              placeholder="Confirm Password"
              v-model="user.confirmPassword"
            />
          </b-col>
        </div>
        <b-alert variant="danger" :show="errmessage !== null">
          {{errmessage}}
        </b-alert>
      </div>
      <div class="mt-2">
        <div class="bg-secondary border-dark shadow-sm p-3 mt-2 mb-0 fixed-bottom">
          <div class="row">
            <div class="col">
              <button type="submit" class="btn golden-btn btn-block" v-if="formState == 'idle'">
                &nbsp;&nbsp;&nbsp;ถัดไป
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="submit" class="btn golden-btn btn-block" v-else>
                <b-spinner small label="Small Spinner" type="grow"></b-spinner>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";

export default {
  name: "RegisterStep3",
  props: ['errmessage','formState'],
  data() {
    return {
      user: {
        firstName: null,
        lastName: null,
        username: null,
        password: null,
        confirmPassword: null
      }
    };
  },
  methods: {
    register(e) {
      e.preventDefault();
      this.$emit('setUser', this.user)
      console.log('set user', this.user)
    },
    isLetter(e) {
      const char = String.fromCharCode(e.keyCode); // Get the character
      if(/^[a-z0-9]+$/.test(char)) return true; // Match with regex 
      else e.preventDefault(); // If not match, don't add to input text
    }
  }
};
</script>

<style lang="scss" scoped>
.code-input {
  border-color: #bd841b !important;
  width: 40px;
  padding: 0;
  margin: 10px 10px;
  font-size: 25px;
  line-height: 40px;
  height: 40px;
  font-family: SukhumvitBold;
  color: #bd841b !important;
}

form {
  label {
    font-family: SukhumvitBold;
  }
}

.code-ref {
  font-size: 20px;
  letter-spacing: 5px;
}

.numpad {
  .btn {
    font-family: SukhumvitBold;
  }

  .btn-reset-form {
    font-size: 100%;
    line-height: 1.5;
    height: 48px;
  }

  .golden-btn-numpad {
    display: inline-block;
    outline: none;
    /* font-family: inherit; */
    font-family: SukhumvitBold;
    box-sizing: border-box;
    border: none;
    border-radius: 0.2em;
    text-transform: uppercase;
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(110 80 20 / 40%),
      inset 0 -1px 2px 1px rgb(139 66 8), inset 0 -1px 1px 2px rgb(250 227 133);
    background-image: linear-gradient(
      160deg,
      #a54e07,
      #b47e11,
      #fef1a2,
      #bc881b,
      #a54e07
    );
    border: 1px solid #a55d07;
    color: rgb(120, 50, 5);
    text-shadow: 0 2px 2px rgb(250 227 133);
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    background-size: 100% 100%;
    background-position: center;
  }
}

.golden-btn {
  display: inline-block;
  outline: none;
  /* font-family: inherit; */
  font-family: SukhumvitBold;
  font-size: 1em;
  box-sizing: border-box;
  border: none;
  border-radius: 0.2em;
  height: auto;
  line-height: 1.9em;
  text-transform: uppercase;
  padding: 3px 0;
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(110 80 20 / 40%),
    inset 0 -1px 2px 1px rgb(139 66 8), inset 0 -1px 1px 2px rgb(250 227 133);
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  );
  border: 1px solid #a55d07;
  color: rgb(120, 50, 5);
  text-shadow: 0 2px 2px rgb(250 227 133);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-size: 100% 100%;
  background-position: center;
}

.text-step {
  font-family: SukhumvitBold;

  .title {
    color: rgb(189, 132, 41) !important;
  }
}

.indexlogo {
  width: 100%;
}

.goldpattern {
  background-size: 100%;
  background: url(../../assets/images/gold-pattern.jpg) top center;
}

.select-btn {
  color: #b47e18 !important;
  background-color: white !important;
  background-image: none;
  border-color: #bd841b !important;
  word-wrap: break-word;
  overflow: hidden;
  display: block;
  font-family: Sukhumvit;
}

.select-btn:hover {
  color: white !important;
  background-color: #bd841b !important;
  background-image: none;
  border-color: #bd841b !important;
}
</style>